export default __webpack_public_path__ + "static/media/logo.87972d5f.png";